import {
  buttonVariants,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  cn,
  LogoModule,
  Separator,
} from '@korint/folio';
import { useKorintUniqConfig } from 'korint-sdk/react';
import { ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Stack } from '@folio/components/ui/flex';
import { Title } from '@folio/components/ui/text';

function LinkBlock({ children, to }: { children: React.ReactNode; to: string }) {
  return (
    <Link
      to={to}
      className={cn(
        buttonVariants({ variant: 'ghost' }),
        'text-base text-foreground flex justify-between',
      )}
    >
      {children}
      <ChevronRightIcon className="w-4 h-4 opacity-80" />
    </Link>
  );
}

export function SuperAdminView() {
  const { title, parentBrokerageFirmId } = useKorintUniqConfig();

  return (
    <Stack align="center" justify="center" gap={0} className="min-h-screen gap-10 bg-background">
      <Stack align="center" justify="center">
        <Title
          order={1}
          size="3xl"
          tone="primary"
          className="flex items-center justify-center gap-2"
        >
          <LogoModule className="h-8 w-auto" /> {title}
        </Title>
      </Stack>
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle>Quick links</CardTitle>
        </CardHeader>
        <CardContent>
          <nav className="flex flex-col gap-2">
            <LinkBlock to="/auth/sign-in">Sign in</LinkBlock>

            <LinkBlock to="/ongoing-new-business">Ongoing new business</LinkBlock>

            {parentBrokerageFirmId && (
              <>
                <Separator />
                <LinkBlock to={`/${parentBrokerageFirmId}/brokerage-firm/creation`}>
                  Brokerage Firm creation funnel
                </LinkBlock>
              </>
            )}
          </nav>
        </CardContent>
      </Card>
    </Stack>
  );
}
